import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import '../../styles/grid/twoColSectionWithImage.scss';

const propTypes = {
  forceImageTop: PropTypes.bool,
  sectionClassName: PropTypes.string,
  smallImage: PropTypes.element,
  largeImage: PropTypes.element,
  imageLocation: PropTypes.oneOf(['left', 'right']),
  imageClassName: PropTypes.string,
  content: PropTypes.element,
  contentClassName: PropTypes.string,
};

const defaultProps = {
  forceImageTop: false,
  sectionClassName: '',
  smallImage: null,
  largeImage: null,
  imageLocation: 'right',
  imageClassName: '',
  content: <div />,
  contentClassName: '',
};

class TwoColSectionWithImage extends PureComponent {
  render() {
    const { smallImage, largeImage, content, sectionClassName, forceImageTop,
      imageClassName, contentClassName, imageLocation } = this.props;

    return (
      <section className={cx('two-col-section-image', sectionClassName)}>
        <div className="image-flex-containers">
          <div className={cx('half-section image', { 'image-top': forceImageTop }, imageLocation, imageClassName)}>
            <div className="show-for-large">
              { largeImage }
            </div>
            <div className="hide-for-large text-center">
              { smallImage }
            </div>
          </div>

          <div className={cx('half-section content', { 'image-top': forceImageTop }, `${imageLocation === 'right' ? 'left' : 'right'}`, contentClassName)}>
            { content }
          </div>
        </div>
      </section>
    );
  }
}

TwoColSectionWithImage.propTypes = propTypes;
TwoColSectionWithImage.defaultProps = defaultProps;
export default TwoColSectionWithImage;
